/**
 * MailingList entity model class
 *
 * This file is part of Minasa
 * (c) Kaden und Partner AG
 */
import BaseModel from './BaseModel';
import BaseCollection from './BaseCollection';

export class MailingList extends BaseModel {
    defaults() {
        return {
            id: null,
            name: null,
            description: null,
        };
    }

    mutations() {
        return {
            id: (id) => (Number(id) > 0 ? Number(id) : null),
        };
    }

    entityName() {
        return 'MailingList';
    }
}

export class MailingListCollection extends BaseCollection {
    options() {
        return {
            model: MailingList,
        };
    }

    entityName() {
        return 'MailingList';
    }
}
